import { ActionCreator } from 'redux';
import { LocationStats, LocationDetails, CampaignInfo, Channel, ChannelLocation } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '@/store';
import {
    LocationInterface,
    LocationWorldFetchStartAction,
    LocationWorldFetchSuccessAction,
    LocationWorldFetchErrorAction,
    LocationWorldParamsInterface,
    LocationWorldChannelFetchStartAction,
    LocationWorldChannelFetchSuccessAction,
    LocationWorldChannelFetchErrorAction,
    LocationWorldChannelParamsInterface,
    LocationCountryFetchStartAction,
    LocationCountryFetchSuccessAction,
    LocationCountryFetchErrorAction,
    LocationCountryParamsInterface,
    LocationCountryChannelFetchStartAction,
    LocationCountryChannelFetchSuccessAction,
    LocationCountryChannelFetchErrorAction,
    LocationCountryChannelParamsInterface,
    AllCampaignsFetchStartAction,
    AllCampaignsFetchSuccessAction,
    AllCampaignsFetchErrorAction,
    AllChannelsFetchStartAction,
    AllChannelsFetchSuccessAction,
    AllChannelsFetchErrorAction,
} from './types';

export const StartLocationsWorldLoading = (params: LocationWorldParamsInterface): LocationWorldFetchStartAction => ({
    type: '@@locationworld/FETCH_START',
    payload: {
        loading: true,
        from: params.from,
        to: params.to,
        offset: params.offset,
        limit: params.limit,
        onlyWithData: params.onlyWithData,
    },
});

export const LocationWorldLoadingFinished: ActionCreator<LocationWorldFetchSuccessAction> = (
    dataSet: LocationStats[]
): LocationWorldFetchSuccessAction => ({
    type: '@@locationworld/FETCH_SUCCESS',
    payload: {
        loading: false,
        dataSet,
        activePage: 1,
    },
});

export const LocationWorldLoadingError: ActionCreator<
    LocationWorldFetchErrorAction
> = (): LocationWorldFetchErrorAction => ({
    type: '@@locationworld/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartLocationWorldChannelLoading: ActionCreator<LocationWorldChannelFetchStartAction> = (
    params: LocationWorldChannelParamsInterface
): LocationWorldChannelFetchStartAction => ({
    type: '@@locationworldchannel/FETCH_START',
    payload: {
        loading: true,
        name: params.name,
        from: params.from,
        to: params.to,
    },
});

export const LocationWorldChannelLoadingFinished: ActionCreator<LocationWorldChannelFetchSuccessAction> = (
    dataSet: ChannelLocation
): LocationWorldChannelFetchSuccessAction => ({
    type: '@@locationworldchannel/FETCH_SUCCESS',
    payload: {
        loading: false,
        dataSet,
        activePage: 1,
    },
});

export const LocationWorldChannelLoadingError: ActionCreator<
    LocationWorldChannelFetchErrorAction
> = (): LocationWorldChannelFetchErrorAction => ({
    type: '@@locationworldchannel/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartLocationCountryLoading: ActionCreator<LocationCountryFetchStartAction> = (
    params: LocationCountryParamsInterface
): LocationCountryFetchStartAction => ({
    type: '@@locationcountry/FETCH_START',
    payload: {
        loading: true,
        countryiso: params.countryiso,
        from: params.from,
        to: params.to,
    },
});

export const LocationCountryLoadingFinished: ActionCreator<LocationCountryFetchSuccessAction> = (
    dataSet: LocationDetails[],
    countryiso: string
): LocationCountryFetchSuccessAction => ({
    type: '@@locationcountry/FETCH_SUCCESS',
    payload: {
        loading: false,
        dataSet,
        activePage: 1,
        countryiso,
    },
});

export const LocationCountryLoadingError: ActionCreator<
    LocationCountryFetchErrorAction
> = (): LocationCountryFetchErrorAction => ({
    type: '@@locationcountry/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartLocationCountryChannelLoading: ActionCreator<LocationCountryChannelFetchStartAction> = (
    params: LocationCountryChannelParamsInterface
): LocationCountryChannelFetchStartAction => ({
    type: '@@locationcountrychannel/FETCH_START',
    payload: {
        loading: true,
        countryiso: params.countryiso,
        name: params.name,
        from: params.from,
        to: params.to,
    },
});

export const LocationCountryChannelLoadingFinished: ActionCreator<LocationCountryChannelFetchSuccessAction> = (
    dataSet: LocationDetails[],
    countryiso: string
): LocationCountryChannelFetchSuccessAction => ({
    type: '@@locationcountrychannel/FETCH_SUCCESS',
    payload: {
        loading: false,
        dataSet,
        activePage: 1,
        countryiso,
    },
});

export const LocationCountryChannelLoadingError: ActionCreator<
    LocationCountryChannelFetchErrorAction
> = (): LocationCountryChannelFetchErrorAction => ({
    type: '@@locationcountrychannel/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartAllCampaignsLoading: ActionCreator<
    AllCampaignsFetchStartAction
> = (): AllCampaignsFetchStartAction => ({
    type: '@@allcampaigns/FETCH_START',
    payload: {
        loading: false,
    },
});

export const AllCampaignsLoaded: ActionCreator<AllCampaignsFetchSuccessAction> = (
    campaigns: CampaignInfo[]
): AllCampaignsFetchSuccessAction => ({
    type: '@@allcampaigns/FETCH_SUCCESS',
    payload: {
        loading: false,
        campaigns,
    },
});

export const AllCampaignsLoadedError: ActionCreator<
    AllCampaignsFetchErrorAction
> = (): AllCampaignsFetchErrorAction => ({
    type: '@@allcampaigns/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const StartAllChannelsLoading: ActionCreator<AllChannelsFetchStartAction> = (): AllChannelsFetchStartAction => ({
    type: '@@allchannels/FETCH_START',
    payload: {
        loading: false,
    },
});

export const AllChannelsLoaded: ActionCreator<AllChannelsFetchSuccessAction> = (
    channels: Channel[]
): AllChannelsFetchSuccessAction => ({
    type: '@@allchannels/FETCH_SUCCESS',
    payload: {
        loading: false,
        channels,
    },
});

export const AllChannelsLoadedError: ActionCreator<AllChannelsFetchErrorAction> = (): AllChannelsFetchErrorAction => ({
    type: '@@allchannels/FETCH_ERROR',
    payload: {
        loading: false,
    },
});

export const getActivityLocationsStore = (state: ApplicationState): LocationInterface => state.activity.locations;
